exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-body[data-v-26306d4b] table > tbody > tr > td {\n\tcursor: pointer;\n}\n.btn[data-v-26306d4b] {\n\tmargin-bottom: 8px;\n}\n.card[data-v-26306d4b] {\n\tposition: relative;\n\tdisplay: flex;\n\tflex-direction: column;\n\tmin-width: 0;\n\tword-wrap: break-word;\n\tbackground-color: #fff;\n\tbackground-clip: border-box;\n\tborder: 1px solid rgba(0, 0, 0, 0.125);\n\tborder-radius: 0.25rem;\n\tpadding: 1.25rem;\n\tflex: 1 1 auto;\n}\n", ""]);

// exports
